/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Clonar rota
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 12/04/2013
 */

import { push } from 'connected-react-router';
import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.Clone = function (tab) {

    this.modalForm = null;
    this.route = null;
    this.parentTab = tab;
    this.blockOverlaySelector = '.mainContainer';

    this.show = function () {
        this.modalForm.showModalForm();
    };

    this.setRoute = function (route) {
        this.route = route;
    };

    /**
     * Faz algumas modificações no ambiente onde o modal será inserido, nesse caso, modifica
     * o CSS do overlay para que ele se ajuste ao esquema de posicionamento dessa aba.
     */

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    this.getLayout = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "attributes": {
                                "class": "monetInlineAlerContainer"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "popup-modal-header"
                                    },
                                    "items": [
                                        {
                                            "tag": "h3",
                                            "html": Monet.I18n.getResourcesByKey("greenmile.routes.cloneroute.modal.title"),
                                        },
                                        {
                                            "tag": "div",
                                            "items": [
                                                {
                                                    "tag": "a",
                                                    "attributes": {
                                                        "href": "https://greenmile.help.descartesservices.com",
                                                        "class": "MonetUIHelpLink",
                                                        "title": "Help"
                                                    },
                                                }
                                            ],
                                            "attributes": {
                                                "class": "MonetUIHelp"
                                            },
                                        }
                                    ]
                                },
                                {
                                    "tag": "div",
                                    "attributes": {
                                        "class": "popup-modal-body"
                                    },
                                    "items": [
                                        {
                                            "tag": "label",
                                            "beforeHtml": data.dateTimeField.label,
                                            "attributes": {
                                                "class": "control-label",
                                                "for": data.dateTimeField.name
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "text",
                                                "id": data.dateTimeField.name,
                                                "name": data.dateTimeField.name,
                                                "value": data.dateTimeField.value,
                                                "class": "datePicker"
                                            }
                                        },
                                        {
                                            "tag": "label",
                                            "beforeHtml": Monet.I18n.getResourcesByKey('Greenmile.Route.Clone.labelKey'),
                                            "attributes": {
                                                "class": "control-label",
                                                "for": "cloneRouteKey"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "id": "cloneRouteKey",
                                                "type": "text",
                                                "class": "textField",
                                                "maxlength": "255"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tag": "div",
                                    "attributes": {
                                        "class": "popup-modal-footer formButtons"
                                    },
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": data.btnSaveValue,
                                                "name": "btn_save_clone_route",
                                                "id": "btn_save_clone_route",
                                                "class": "btn",
                                                "style": "width: 170px"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": data.btnExitValue,
                                                "name": "btn_exit_clone_route",
                                                "id": "btn_exit_clone_route",
                                                "class": "btn secondary",
                                                "style": "width: 75px"
                                            }
                                        }
                                    ],
                                }
                            ],
                        }
                    ],
                    "attributes": {
                        "id": "formCloneFormTemplate"
                    }
                }
            ]
        }).render();
    };

    /**
     * Monta a estrutura base do formulário, pega o template e insere o conteúdo no modalForm
     */

    this.createForm = function () {

        const modalContainer = document.querySelector("#" + this.parentTab + " .popupFormContainer");
        let jqueryUiFormat = null;
        const date = Monet.Format.Date.getFormattedLocaleToday();

        if (modalContainer !== null) {

            modalContainer.appendChild(this.getLayout({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Route.Clone.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Route.Clone.btnExit'),
                dateTimeField: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.Clone.dateTimeFieldLabel'),
                    name: 'cloneTime',
                    value: date
                }
            }));

            jqueryUiFormat = Monet.I18n.locale.dateFormat.toLowerCase();
            jqueryUiFormat = jqueryUiFormat.replace("yyyy", "yy");

            $("#" + this.parentTab + " .popupFormContainer .datePicker").datepicker({
                dateFormat: jqueryUiFormat,
                beforeShow: function (input, inst) {
                    inst.dpDiv.css({
                        'margin-top': '0px',
                        'margin-left': '0px'
                    });

                }
            });

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }

    };

    this.addEventListeners = function () {

        try {
            var error = null;
            var that = this;
            var btnSave = document.querySelector("#formCloneFormTemplate #btn_save_clone_route");
            var btnExit = document.querySelector("#formCloneFormTemplate #btn_exit_clone_route");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doComplete();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.");
            error.console();

        }

    };

    this.doComplete = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var that = this;
        var error = null;

        if (isValid) {
            this.modalForm.toggleLoadingInModalBtn();
            formDataJson = this.getFormValues();

            if (this.route !== null) {

                const request = new DefaultRequest({
                    url: 'Route/Clone/' + this.route.id,
                    method: 'post',
                    data: formDataJson,
                    success: function (data) {
                        that.modalForm.closeModalWindow();
                        that.successCallback(data);
                    },
                    error: function (data) {

                        var returnObj = JSON.parse(data.responseText);
                        that.modalForm.toggleLoadingInModalBtn();
                        if (returnObj.errorMessages[0].resource.i18nMessage) {
                            that.errorCallback(data);
                        } else {
                            that.modalForm.closeModalWindow();
                        }

                    }

                });
                request.send();

            } else {
                error = new Monet.Exception.ReturnError(this,
                    "route can't be null");
                error.console();
            }
        }

    };

    this.getFormValues = function () {

        var cloneTimeField = document.querySelector("#formCloneFormTemplate .datePicker");
        var cloneKeyField = document.querySelector("#formCloneFormTemplate #cloneRouteKey");

        var formattedDate = Monet.Format.Date.parseLocaleToISOString(cloneTimeField.value);

        var objToSend = {
            date: formattedDate,
            key: cloneKeyField.value
        };

        return objToSend;
    };

    this.goToEditRoute = (route) => {
      if (!route) return;

      window.globalStore.dispatch(push(`/Route/edit/${route.id}`));

      if (document.querySelector('#Route')) {
        $('#tabs').tabs('option', 'active', $('#tabs ul li[aria-controls="Route"]').index());
      }
    };

    this.successCallback = function (data) {
      if (this.parentTab === 'RouteMonitor') {
        this.goToEditRoute(data);

        return;
      }

      let router;
      let routerEntity;

      if (this.parentTab === 'Route') {

        router = new App.Routers.Route();
        routerEntity = 'Route';

      } else {

        router = new App.Routers.RouteSummaryRoutes();
        routerEntity = 'RouteSummaryRoutes';
      }

      Monet.Grid.Utils.clearPagination(routerEntity);
      router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, true);

      this.goToEditRoute(data);
    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope("#formCloneFormTemplate");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

    this.validateForm = function () {

        var isValid = true;
        var error = null;
        var cloneTime = document.getElementById("cloneTime");
        var key = document.getElementById('cloneRouteKey');
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formCloneFormTemplate';

        try {

            if (cloneTime.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "clone_date",
                    "Route.Clone.cantCloneWithoutDateTime"
                );

                isValid = false;
                return;
            }

            if (key.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "clone_key",
                    "Route.Clone.cantCloneWithoutKey"
                );

                isValid = false;

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.addEventListeners();
        };
    }(this);

    const init = function (scope) {

        return function (scope) {

            const selector = "#" + scope.parentTab;

            const options = {
                width: 280,
                height: 258,
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);

};
